export const options = {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN || '.app.newspage.media',
};
